/** @jsxImportSource @emotion/react */
import { Link } from "react-router-dom";
import { useGetProfileScreenStyles } from "./index.styles";
import appLogo from "../../../assets/images/svg/appLogo.svg";
import FAQContent from "./FAQContent";
import Footer1 from "../../../components/Footer/Footer";
import ScrollToTopButton from "../../../components/ScrollToTopButton";

const Faq = () => {
  const classes = useGetProfileScreenStyles();

  return (
    <div>
      <div css={classes.privacyContainer}>
        <Link to="/home">
          <div css={classes.logo}>
            <img height={38} src={appLogo} alt="money mails logo" />
          </div>
        </Link>
        <FAQContent />
      </div>
      <Footer1 />
      <ScrollToTopButton />
    </div>
  );
};

export default Faq;
